"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_config_1 = __importDefault(require("./utils.config"));
var UtilsService = /** @class */ (function (_super) {
    __extends(UtilsService, _super);
    function UtilsService(BASE_URL, FUNCTIONS_KEY) {
        var _this = _super.call(this, BASE_URL, FUNCTIONS_KEY) || this;
        //Gravedad nuevo
        _this.getAllAccidentSeverity = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/accidente-grados-lesion")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        //botiquin nuevo
        _this.getAidKit = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/botiquines")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.getBilling = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v1/get-billing")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // /api/v1/calculator-fees-selfemployee
        _this.calculatorFeesSelfemployee = function (data) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.post("/api/v1/calculator-fees-selfemployee", data)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // /api/v1/calculator-absenteeism
        _this.calculatorAbsenteeism = function (data) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.post("/api/v1/calculator-absenteeism", data)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        //causas alta nuevo
        _this.getAllCauseOfHigh = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/causas-alta")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.getAllCity = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v1/get-all-city")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.getAllLocations = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/localidades")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        //localidad nuevo
        _this.getAllCityUser = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/municipios")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        //municipios por provincia
        _this.getCityByProvinceUser = function (idProvincia) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/municipios?codPovincia=".concat(idProvincia))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.getFilterCityUser = function (query) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v1/get-filter-city-user?filter=".concat(query))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // cnaes nuevo
        _this.getAllCnae = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/cnaes")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // cnaes Company 3 digitos
        _this.getAllCnaeCompany = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/cnaes/3digitos")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // cnaes Employee 4 digitos
        _this.getAllCnaeEmployee = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/cnaes/4digitos")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // cnos nuevo
        _this.getAllCno = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/cnos")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // cnos Letra
        _this.getAllCnoLetter = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/ocupacionesATEP")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.getAllCno3Digi = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/cnos/3digitos")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        //tipos-contrato nuevo
        _this.getAllContract = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/tipos-contrato")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // accidente-formas-contacto nuevo
        _this.getAllContactForm = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/accidente-formas-contacto")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        //PAISES nuevo
        _this.getAllCountry = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/paises")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        //accidente-desviaciones nuevo
        _this.getAllDesviation = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/accidente-desviaciones")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // accidente-partes-cuerpo-lesionada nuevo
        _this.getAllInjuryPartOfBody = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/accidente-partes-cuerpo-lesionada")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        //accidente-agentes-material nuevo
        _this.getAllMaterialAgent = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/accidente-agentes-material")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        //provincias nuevo
        _this.getAllProvince = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/provincias")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        //provincias-delegaciones nuevo
        _this.getAllProvinceUser = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/provincias-delegacion")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.getSeedUtil = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v1/seed-util")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // regimenes por Id nuevo
        _this.getSocialSecurityRegimen = function (regimenId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/regimen/".concat(regimenId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // regimenes nuevo
        _this.getAllSocialSecurityRegimen = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/regimenes")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // accidente-actividades-fisica nuevo
        _this.getSpecificActivity = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/accidente-actividades-fisica")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // tipo documento-identificacion nuevo
        _this.getTypeDocument = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/tipo-documentos-identificacion")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // accidente-tipos-lesion nuevo
        _this.getTypeInjury = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/accidente-tipos-lesion")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        //accidente-tipos-lugar nuevo
        _this.getTypePlace = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/accidente-tipos-lugar")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // tipos-calle nuevo
        _this.getTypeRoad = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/tipos-calle")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        //accidente-tipos-trabajo nuevo
        _this.getTypeWork = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/accidente-tipos-trabajo")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.getAidKeyAvailable = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v1/get-aid-key-available")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.createOrderRequest = function (OrderRequest) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.post("/api/v1/create-order-request", OrderRequest)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.getAffiliation = function (Term, Birthdate) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v1/get-affiliation?term=".concat(Term, "&birthdate=").concat(Birthdate))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.getAffiliationById = function (Id) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v1/get-affiliation-by-id?Id=".concat(Id))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.getDelegatedPayment = function (GetDelegatedPaymentRequest) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v1/get-delegated-payment", { params: GetDelegatedPaymentRequest })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        /**
      * API name: getCentersByProvince
      */
        _this.getCentersByProvince = function (provincia) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/centros/provincia/".concat(provincia))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        /**
      * API name: getMainCenters
      */
        _this.getMainCenters = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/centros/solimat")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        /**
      * API name: getCenter
      */
        _this.getCenter = function (centroId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/centro/".concat(centroId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.getCausasPagoDirecto = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/causas-pago-directo")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        //Contingencias
        _this.getContingencias = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/contingencias")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        //Regimenes Seguridad Social Pago Directo
        _this.getRegimenesSeguridadSocialPagoDirecto = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/regimenes-seguridad-social-pago-directo")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        //Regimenes Seguridad Social Pago Directo
        _this.getRegimenesSeguridadSocialPagoDirectoTipo = function (tipo) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/regimenes-seguridad-social-pago-directo/".concat(tipo))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        //Regimenes Formularios Generales
        _this.getRegimenesFormulario = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/regimenes-formulario")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        //Actividad Economica
        _this.getActividadEconomica = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/actividades-economicas")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        return _this;
    }
    return UtilsService;
}(utils_config_1.default));
exports.default = UtilsService;
